import Vue from 'vue'
import Clipboard from 'clipboard'

const clipboardSuccess = () => {
  Vue.prototype.$message({
    message: 'copy successful',
    type: 'success',
    duration: 1500
  })
}

const clipboardError = () => {
  Vue.prototype.$message({
    message: 'copy error',
    type: 'error'
  })
}

export const handleClipboard = (text, event, onSuccess, onError) => {
  event = event || {}
  const clipboard = new Clipboard(event.target, {
    text: () => text
  })
  clipboard.on('success', () => {
    onSuccess ? onSuccess() : clipboardSuccess()
    clipboard.off('error')
    clipboard.off('success')
    clipboard.destroy()
  })
  clipboard.on('error', () => {
    onError ? onError() : clipboardError()
    clipboard.off('error')
    clipboard.off('success')
    clipboard.destroy()
  })
  clipboard.onClick(event)
}



// WEBPACK FOOTER //
// ./src/utils/copy.js